<template lang="pug">
.playlists-wrapper
  .md-headline Playlist+
  // Create playlist
  md-layout(md-flex='100', v-show='createMode')
    md-input-container(:class='{ "md-input-invalid" : $v.playlist.name.$error }')
      div
        md-input(v-model='playlist.name', placeholder='Playlist name...', @blur.native="$v.playlist.name.$touch()")
        span.md-error(v-if='$v.playlist.name.$error && !$v.playlist.name.required') This field is required
        span.md-error(v-if='$v.playlist.name.$error && !$v.playlist.name.isUnique && !$v.playlist.name.$pending') Must be unique
    md-layout(md-flex='100', md-align='end')
      md-spinner.md-warn(md-indeterminate, :md-size='35', v-if='creatingPlaylist')
      md-button(@click='resetForm', v-if='!creatingPlaylist')
        | Cancel
      md-button.submit-btn.md-raised.md-primary(@click='createPlaylist', :disabled='$v.$invalid', v-if='!creatingPlaylist')
        | Create
  // Playlist selector
  md-layout#playlist-index-container.playlist-details(v-show='!createMode')
    md-layout#select-playlist-or-create-index.playlist-add(md-flex='100')
      md-layout(md-flex='85')
        playlist-selector.selector(ref='playListSelector', v-model='playlistId', :emitObject='true', @selectedPlayList='updateSelectedPLayList')
      md-layout.on-right(md-flex='10')
        md-spinner.md-warn(md-indeterminate, :md-size='35', v-show='loading')
        md-button#create-playlist-index.md-icon-button.md-raised.md-accent.md-dense.btn(@click='createMode = true', v-show='!loading', md-theme='blue')
          md-icon.icon(md-iconset="fa fa-plus")
    // Drag and drop info
    .info(v-if='hasItemsToShow')
      md-icon.md-accent(md-iconset="fa fa-info-circle")
      span.md-caption Drag and drop the playlist items to sort them.
    // Playlist items
    md-layout#items-index-container(md-flex='100')
      SlickList#items-list-index-playlist(lockAxis="y", v-model="selectedPlaylistItems", v-if='hasItemsToShow',  :pressDelay='100', @sort-start='handleDragStart', @sort-end='handleDragEnd').md-list.custom-list.md-triple-line
        SlickItem.itemPlaylist(v-for="(item, index) in selectedPlaylistItems", :index="index", :key="index").md-list-item.sortable-item
          .md-list-item-container
            // Avatar
            md-avatar
              img(:src='getVideoPoster(item)', :alt='item.name')
            // Name
            .md-list-text-container
              span.title {{ item.name }}
              span.detail {{ secondsToHms(item.duration || item.videoDuration) }}
              span.detail {{ item.credit }}
            // Actions
            md-button#delete-item-index-playlist.md-icon-button.md-warn.md-list-action.btn-icon(@click='removeItemAt(index)')
              md-icon.icon(md-iconset="fa fa-trash-alt")
            // Item divider
            md-divider

      // No results
      md-layout(v-else)
        span.md-subheader.no-results
          md-icon.md-accent(md-iconset="fa fa-exclamation-circle")
          | No items in this playlist
    // Distribute playlist
    md-layout.btn(md-flex='100', v-if='hasItemsToShow')
      md-button.btn-child.md-raised.md-primary(@click='distributePlaylist', md-theme='blue')
        | Distribute
</template>

<script>
import { SlickList, SlickItem } from 'vue-slicksort';
import { mapGetters, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import videoMixin from '../videomixins';
import Loader from '../../shared-components/Loader';
import PlaylistSelector from '../../shared-components/playlist/PlaylistSelector';
import playlistService from '../../services/playlistService';

export default {
  mixins: [videoMixin, validationMixin],
  components: {
    stitchLoader: Loader,
    SlickItem,
    SlickList,
    PlaylistSelector,
  },
  computed: {
    ...mapGetters('playlist', {
      hasItemsToShow: 'hasItems'
    }),
    currentPlaylist: {
      get() {
        return this.$store.getters['playlist/playlist'];
      },
      set(value) {
        this.playlistId = value._id;
        this.$store.dispatch('playlist/setPlaylist', value);
      }
    },
    selectedPlaylistItems: {
      get() {
        return this.$store.getters['playlist/items'];
      },
      set(items) {
        this.$store.dispatch('playlist/setPlaylistItems', items);
        this.savePlaylist()
      }
    }
  },
  data() {
    return {
      loading: false,
      createMode: false,
      creatingPlaylist: false,
      playlist: {
        name: '',
        items: [],
        status: 'public',
      },
      playlistId:''
    };
  },
  validations: {
    playlist: {
      name: {
        required,
        async isUnique(value) {
          if (value.length > 0) {
            const response = await playlistService.getList({ name: value, limit: 1 });
            return response.data.total === 0;
          } else {
            return true;
          }
        }
      }
    }
  },
  methods: {
    showAlertToast(text, icon) {
      this.$swal({
        text: text,
        position: 'bottom-left',
        icon: icon,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      }
      )
    },

    //event added to fix issue select element when user drags. Only happened in safari
    handleDragStart() {
      document.body.classList.add('disable-selection');
    },
    handleDragEnd() {
      document.body.classList.remove('disable-selection');
    },

    ...mapActions('playlist', ['removeItemAt']),
    createPlaylist() {
      this.creatingPlaylist = true;
      this.$store.dispatch('playlist/create', this.playlist)
        .then(() => {
          this.showAlertToast('Playlist created', 'success');
          this.resetForm();
          this.creatingPlaylist = false;
          this.$refs.playListSelector.reload();
        })
        .catch(() => {
          this.showAlertToast('Something wrong!', 'error');
          this.$emit('error', 'Error while creating the playlist');
          this.creatingPlaylist = false;
        });
      },

    savePlaylist() {
      this.loading = true;
      this.$store.dispatch('playlist/save')
        .then(() => {
          this.loading = false;
          this.showAlertToast('Playlist Saved', 'success');
        })
        .catch(() => {
          this.loading = false;
          this.showAlertToast('Something wrong!', 'error');
        });
    },
    distributePlaylist() {
      this.$router.push({
        name: 'CreateDistribution',
        query: {
          sourceType: 'playlist',
          sourceId: this.currentPlaylist._id
        }
      });
    },
    updateSelectedPLayList(value) {
      this.currentPlaylist = value;
    },
    resetForm() {
      this.createMode = false;
      this.playlist.name = '';
      this.$v.$reset();
    }
  },
  mounted() {
    this.loading = true;
    this.$store.dispatch('playlist/getLastUpdatedPlaylist')
    .then((resp) => {
      this.playlistId = resp._id;
      this.loading = false;
    })
      .catch(() => {
        this.loading = false;
        this.$emit('error', 'Error while retrieving the last update playlist. Please, try again later.');
      });
  }
};
</script>

<style lang="scss" >
.md-subheading {
  display: none;
}

.playlists-wrapper {
  padding: 5px;

  .playlist-details {
    width: 100%;

    .custom-list {
      width: 100%;
      margin-bottom: 15px;

      .sortable-item {
        cursor: pointer;

        .md-list-text-container {
          padding: 8px 0;

          .title {
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 10px;
          }

          .detail {
            color: rgba(0, 0, 0, 0.54);
          }
        }
      }
    }
  }
}

@media(max-width: 1024px) {
  .title {
    font-size: 14px;
  }

  .detail {
    font-size: 12px;
  }
}

.btn-icon {
  margin-left: 5px !important;
}

.playlist-add {
  padding: 5px;
  justify-content: space-between;

  @media(max-width: 1111px) {
    padding-right: 22px !important;
  }
}

.itemPlaylist {
  cursor: grab !important;
}



.btn {
  flex-wrap: wrap;
  justify-content: center;
}

.btn-child {
  width: 110px;
  padding: 2px;
}

.submit-btn {
  margin-right: 0;
}

.on-left {
  margin-right: 5px;
  margin-top: -5px;
}

.on-right {
  align-items: center;
  margin-right: 5px;
}

.no-results {
  padding-left: 0;

  .md-icon {
    margin-right: 5px;
  }
}

.info {
  .md-icon {
    margin: -3px 5px 0 0;
  }
}

.bounce-move {
  transition: transform 1s;
}

.md-headline {
  margin-bottom: 5px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/playlist/Playlists.vue